import { Component, Inject, OnDestroy, OnInit , Input ,Output,ViewChild} from '@angular/core';
import { Store } from '@src/store';
// import { projectActions } from "../../../../../../store/reducers/projectReducer";
import { SessionService } from '@src/services';
import { environmentsActions } from '../../../../../../store/reducers/environmentsReducer';
// import { cmsActions } from '../../../../../store/reducers/cmsReducer';
 import { projectsActions } from '../../../../../../store/reducers/projectsReducer';
 import { DialogManagerService } from '@src/services';
// import { backupsActions } from '../../../../../store/reducers/backupsReducer';
// import {packagesActions} from '../../../../../store/reducers/packagesReducer';
import {RunPackageDialogComponent} from "@app/shared/components/dialogs/run-package-dialog/run-package-dialog.component";
import {UpdateDevEnvDialogComponent} from "@app/shared/components/dialogs/update-devenv-dialog/update-devenv-dialog.component";
import { chartStatus } from "../../../../../../constants";
import _ from 'lodash';
import * as _str from 'underscore.string';
import moment from "moment";
import { consts } from '@src/constants/consts';
import { EventEmitter } from '@angular/core';


@Component({
    selector: 'environment',
    template: require('./environment.html')
})

export class EnvironmentComponent implements OnInit , OnDestroy {


       @Input() public environmentSync;
       @Input() public _environments;
       @Input() public environmentStatus;
       @Input() public environmentTypeFlowType
       @Input() public envConfig
       @Input() public environmentVersion
       @Input() public RMid;
       @Output() public getRmId = new EventEmitter()
       @Output() public onEditModeDblClick = new EventEmitter()
       @Output() public onEnvDblClick = new EventEmitter()
       @Output() public onUpdateToVersion = new EventEmitter()
       @Output() public onUpdateSourceControl = new EventEmitter()
       @Output() public onBackupEnvironment = new EventEmitter()
       @Output() public onRestoreEnvironment = new EventEmitter()
       @Output() public onApplyLabel = new EventEmitter()
       @Output() public onSetType  = new EventEmitter()
       @Output() public onValidate = new EventEmitter()
       @Output() public onViewLabel = new EventEmitter()
       @Output() public onBuild = new EventEmitter()
       @Output() public onBuildByTask = new EventEmitter()
       @Output() public onDblClick = new EventEmitter()
       @Output() public onSetVersion = new EventEmitter()
       @Output() public onExitIntegration = new EventEmitter()
       @Output() public onRollback = new EventEmitter()
       

       @Input() set environment(value) {
        this._environment = value;
        
        if (this._environment && this.environmentStatus !== 0 && this.environmentStatus) {            
            this.statusClass = chartStatus[this.environmentStatus].statusClass;
        }
        if (this.environmentTypeFlowType == -1) //dev env
            this._environment.isDev = true;
    }
    
       
      public _environment:any
      public packagesData:any
      public pageId = 1;
      public quantity = 15;
      public statusClass:any;
      public autoRestoreItems = [];
      public autoRestoreSelected;
      public autoBackupSelected;
      public defaultBackup;
      public defaultAutoRestore;
      public lastDeployInfo = null;
      public dbFlags;
      public deployInfo:any;
      public projectId:any
      public UseDowngradeScripts:boolean = true;
      public scrollEnvs;
      public dplModeType:any
      public search:any;
      public lastPackage = null;
      public unSubscribe:any
      public m_envActions:any
      public presentage:any;
      public lastSync = null;
      @ViewChild('childMenu') public childMenu: any;

    constructor(@Inject('processDetailsModalService') private processDetailsModalService: any , private sessionService:SessionService , private dialogManagerService: DialogManagerService ,@Inject('dbTypeService') private dbTypeService: any, @Inject('$scope') public $scope: any, public store : Store, @Inject('$state') public state: any,@Inject('$stateParams') public $stateParams: any) {
        this.projectId = this.$stateParams.id;

        
    }

    ngOnInit() { 
        this.sessionService.UpdatePresentageSubject$.subscribe(data =>{
            if(data){
                this.presentage = data
            }
        })
        this.$scope.$watch(() => this.environmentSync, (newVal, oldVal) => {
            if (!oldVal && !newVal) {
                return;
            }
            if (this.environment && this.environment.isDev)
            {
                this.lastSync = this._environment.lastVersionSync;
            }
        });

        this.$scope.$watch(() => this.environmentVersion, (newVal, oldVal) => {
            if (!oldVal && !newVal) {
                return;
            }
            if (this.environment && this.environment.isDev)
            {
                this.lastPackage = this._environment.latestTempOrAdhocVersionName;
            }
        });

        this.$scope.$watch(() => this.environmentStatus, (newVal, oldVal) => {
            if (!oldVal && !newVal) {
                return;
            }
            if (this.environment && this.environmentStatus !== 0 && this.environmentStatus) {
                this.statusClass = chartStatus[this.environmentStatus].statusClass;

            }
            if (this.environment && this.environmentStatus === 5) {
                this.environment["PercentageComplete"] = 0
            }
            /*
            if (_this.environment && _this.environment.isDev)
            {
                this.lastPackage = this._environment.latestTempOrAdhocVersionName;
                this.lastSync = this._environment.lastVersionSync; 
            }
            */
            setTimeout(() => {
                this.$scope.$apply();
            }, 50);
        });
        this.unSubscribe = this.store.subscribe(() => {
            this.deployInfo = this.store.getState().projects.deployInfo;
            if (this.deployInfo) {
                if (this.lastDeployInfo) {
                    if (!this.deepEquals(this.deployInfo, this.lastDeployInfo)) {
                        this.lastDeployInfo = { ...this.deployInfo};
                    }
                } else {
                    this.lastDeployInfo = {...this.deployInfo};
                }
            }
        });


        this.$scope.$watch(
            () => this.store.getState().projects.projectWithMetaData,
            (newVal, oldVal) =>{
                if(oldVal){}
                this.setEnvActions(newVal)
            } );
    }


    ngOnDestroy(): void {
        this.unSubscribe();
    }

    deepEquals(x, y) {
        if (x === y) {
          return true; // if both x and y are null or undefined and exactly the same
        } else if (!(x instanceof Object) || !(y instanceof Object)) {
          return false; // if they are not strictly equal, they both need to be Objects
        } else if (x.constructor !== y.constructor) {
          // they must have the exact same prototype chain, the closest we can do is
          // test their constructor.
          return false;
        } else {
          for (const p in x) {
            if (!x.hasOwnProperty(p)) {
              continue; // other properties were tested using x.constructor === y.constructor
            }
            if (!y.hasOwnProperty(p)) {
              return false; // allows to compare x[ p ] and y[ p ] when set to undefined
            }
            if (x[p] === y[p]) {
              continue; // if they have the same strict value or identity then they are equal
            }
            if (typeof (x[p]) !== 'object') {
              return false; // Numbers, Strings, Functions, Booleans must be strictly equal
            }
            if (!this.deepEquals(x[p], y[p])) {
              return false;
            }
          }
          for (const p in y) {
            if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
              return false;
            }
          }
          return true;
        }
      }

      isMenuDisable() {
        const isEditMode = this.store.getState().project.editMode || false;
        const isDraft = (this.store.getState().projects.projectWithMetaData) ? this.store.getState().projects.projectWithMetaData.isDraft || false : false;
        return isEditMode || isDraft || this._environment.isTest;
    }

    get environment() {
        return this._environment;
    }

    getEnvActions = () => {
        if(this.m_envActions != undefined){
            return this.m_envActions;
        }
        return []
    };

    IsDisabled = () => {
        const editMode = this.store.getState().project.editMode;
        return editMode && editMode === true ? '' : 'disabled';
    }

    createTemplate = (value) => {
        const envActionsTemplate = [];
        const envActions = _.cloneDeep(value);
        for (const envAction in envActions) {
            if (envActions[envAction])
                envActionsTemplate.push(envActions[envAction]);
        }
        return envActionsTemplate;
    }

    setEnvActions = (newVal) => {
        const projectWithMetaData = this.store.getState().projects.projectWithMetaData;
        const envId = this.environment.id;
        if (newVal != null) {
            let envActions = projectWithMetaData.envActions[envId];
            this.m_envActions = this.createTemplate(envActions);
        }
    }

    isManagedRS = (environment) => {
        return environment.isRMSource === true && environment.isManaged === true;
    }

    clickEnvAction = (action) => {
        switch (action.actionName) {
            case consts.envActions.Upgrade:
                const upgradeCall = this.onUpdateToVersion;
                upgradeCall.emit({data: this.environment ,type :consts.envActions.Upgrade});
                // }
                break;           
            case consts.envActions.PreValidate:
                  this.onUpdateToVersion.emit({data: this.environment ,type: consts.envActions.PreValidate})
                break;
            case consts.envActions.UpdateSourceControl:
                this.onUpdateSourceControl.emit({ data: this.environment });
                break;                  
            case consts.envActions.BackupEnvironment:
                this.onBackupEnvironment.emit({ data: this.environment });
                break;                
            case consts.envActions.RestoreEnvironment:
                this.onRestoreEnvironment.emit({ data: this.environment });
                break;
            case consts.envActions.ApplyLabel:
                this.onApplyLabel.emit({ data: this.environment });
                break;
            case consts.envActions.SetType:
                this.onSetType.emit({ data: this.environment });
                break;
            case consts.envActions.Validate:
                this.onValidate.emit({ data: this.environment });
                break;
            case consts.envActions.ViewLabels:
                this.onViewLabel.emit({ data: this.environment });
                break;
            case consts.envActions.Build:
                this.onBuild.emit({ data: this.environment });
                break;
            case consts.envActions.BuildByTask:
                this.onBuildByTask.emit({ data: this.environment, type : action });
                break;
            case consts.envActions.Details:
                this.onDblClick.emit({ data: this.environment });
                break;
            case consts.envActions.SetVersion:
                this.onSetVersion.emit({ data: this.environment });
                break;
            case consts.envActions.ExitIntegration:
                this.onExitIntegration.emit({ data: this.environment });
                break;
            case consts.envActions.Rollback:
                this.onRollback.emit({ data: this.environment });
                break;
            case consts.envActions.Downgrade:
                break;
            case consts.envActions.DeployScript:
                break;
            case consts.envActions.Compare:
                break;
            case consts.envActions.GetSpecific:
            case consts.envActions.GetLatest:
                const isGetLatest = action.actionName === consts.envActions.GetLatest;
                if (isGetLatest) {
                    this.store.dispatch({
                        type: environmentsActions.GET_BASELINE_FOR_GET_LATEST,
                        payload: {
                            projectId: this.projectId, envId: this.environment.id
                        }
                    }).then(response => {
                        this.showUpdateEnv(isGetLatest, response.data);
                    });
                } else {
                    this.showUpdateEnv(isGetLatest, null);
                }
                break;
            case consts.envActions.RunPackage:
                this.showRunPackage();
                break;
            default:
                break;
        }
    };

    showRunPackage() {
        Promise.all([
            //this.store.dispatch({
            //    type: environmentsActions.GET_VERSIONS_FOR_UPGRADE,
            //    payload: { projectId: this.projectId, envId: this.environment.id }
            //}),
            this.store.dispatch({
                type: projectsActions.GET_PROJECT_META_DATA,
                payload: { projId: this.projectId }
            })
        ]).then(([projectResponse]) => {
            const projectData = projectResponse.data;
            this.dbTypeService.getFlags(projectData.dbTypeId).then((dbTypeResponse) => {
                const scriptTypes = [
                    { name: 'Upgrade', value: 1 },
                    { name: 'Downgrade', value: 2 }
                ];
                const useDowngradeScripts = !dbTypeResponse.HasDevEnv || projectData.options.UseDowngradeScripts;

                const onConfirm = (data) => {
                    this.store.dispatch({
                        type: environmentsActions.RUN_PACKAGE,
                        payload: {
                            projectId: this.projectId,
                            envId: this.environment.id,
                            packageId: data.selectedPackage.id,
                            skipCheckedOut: false,
                            scriptType: data.selectedScriptType.value
                        }
                    });
                }
                const dialogData = {
                    title: 'Run Package',
                    envName: this.environment.name,
                    useDowngradeScripts: useDowngradeScripts,
                    selectedPackage: null,
                    packages: null,
                    scriptTypes: scriptTypes,
                    selectedScriptType: scriptTypes[0],
                    projectId: this.projectId
                };
                this.dialogManagerService.showDialog(dialogData, onConfirm, RunPackageDialogComponent, 'run-package-dialog');

            });
        });
        //make the watch update
        this.environmentStatus = this.environmentStatus;
    }

    showUpdateEnv(isGetLatest, baselineId) {
        this.store.dispatch({
            type: environmentsActions.GET_LABELS,
            payload: { projectId: this.projectId, envId: this.RMid }
        }).then(rmResponse => {
            const baselines = _.uniqBy(rmResponse.data, 'name');
            
            const notSelectedBaseline = { id: null, name: 'None' };
            const selectedBaseline = baselines.find(x => x.id === baselineId) || notSelectedBaseline;
            baselines.unshift(notSelectedBaseline);
            Promise.all([
                this.store.dispatch({
                    type: environmentsActions.GET_LABELS_FOR_VALIDATE,
                    payload: { projectId: this.projectId, envId: this.environment.id }
                }),
                this.store.dispatch({
                    type: environmentsActions.GET_PACKAGES_FOR_VALIDATE,
                    payload: { projectId: this.projectId, envId: this.environment.id }
                })
            ]).then(response => {
                const packages = response.find(x => x.type === environmentsActions.GET_PACKAGES_FOR_VALIDATE).data;
                const labels = response.find(x => x.type === environmentsActions.GET_LABELS_FOR_VALIDATE).data;
                const foundPackage = isGetLatest && packages && packages.length > 0 ? packages[0] : null;
                const selected = foundPackage ? foundPackage.id.toString(): null;
                const projectData = this.store.getState().projects.projectWithMetaData;
                const isByTask = projectData.dplModeType === consts.deploymentType.ByTask;

                const onConfirm = (data) => {
                    this.store.dispatch({
                        type:  environmentsActions.UPDATE_DEV_ENV,
                        payload: {
                            projectId: this.projectId,
                            envId: this.environment.id,
                            isPackageByLabel: data.selectedAction === consts.actionType.ByLabel,
                            packageId: String(data.selected),
                            skipCheckedOut: false,
                            createScriptOnly: data.viewScript,
                            baselineId: data.baselineSelected.id
                        }
                    });
                }
                const dialogData = {
                    title: isGetLatest ? 'Get latest' : 'Get specific',
                    envName: this.environment.name,
                    isManagedEnv: this.environment.isManaged,
                    skipCheckedOut: false,
                    viewScript: false,
                    baselines: baselines,
                    baselineSelected: selectedBaseline,
                    labels: labels,
                    byactions: packages,
                    packages: packages,
                    selectedPackage: foundPackage,
                    selectedLabel: null,
                    selected: selected,
                    actions: consts.actionType,
                    deploymentTaskMode: isByTask,
                    selectedAction: consts.actionType.ByPackage,
                    button: isGetLatest ? 'Get latest' : 'Get specific'
                   
                };
                this.dialogManagerService.showDialog(dialogData, onConfirm, UpdateDevEnvDialogComponent, 'update-devenv-dialog');

            });
        });
    }


    convertUTCtoLocal(date, format) {
        if (!date)
            return '';
        if (date == "01/01/0001 00:00") {
            if (format == "HH:mm:ss") {
                return "00:00";
            }
            return "01/01/0001"
        } else {
            const stillUtc = moment.utc(date, "DD/MM/YYYY HH:mm");
            if (stillUtc.isValid()) {
                const local = moment(stillUtc.toDate()).local().toDate();
                const datee = local;
                
                if (format == 'time')
                    return local.toLocaleString([], { hour: 'numeric', minute: 'numeric' });
                else if (format == 'date')
                    return datee.toLocaleString([], { day: 'numeric', month: 'numeric', year: 'numeric' });
            } else {
                if (format == "HH:mm:ss") {
                    return "00:00";
                }
                return "01/01/0001"
            }
        }
    }

    onDriftClick(jobId) {
        this.processDetailsModalService.OpenProcessDetailsModal({ JobQId: jobId }, true)
    }

    setSpace = (item) => item.replace(/([A-Z]+)/g, " $1");
    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/pipeline/environments-ang7/environment/environment.ts